export default __webpack_public_path__ + "static/inc-5000-da03098ed8c6c6269a01d91c98866b72.png";